import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ConstantContactCampaignDetail } from '../constant-contact-campaign-detail';

@Component({
  selector: 'app-constant-contact-campaign-detail',
  templateUrl: './constant-contact-campaign-detail.component.html',
  styleUrls: ['./constant-contact-campaign-detail.component.css']
})
export class ConstantContactCampaignDetailComponent {

  htmlContent: SafeHtml = "";
  selectedContent: ConstantContactCampaignDetail | null = null;
  @ViewChild("contentContainer") contentContainer: ElementRef | null = null;
  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private sanitizer: DomSanitizer
  ){
    let campaignId = this.route.snapshot.paramMap.get("campaignId");
    httpService.getConstantContactCampaignDetail(campaignId!).subscribe(res => {
      this.htmlContent = sanitizer.bypassSecurityTrustHtml(res.htmlContent);
      this.selectedContent = res;
    });
  }

downloadHtml(){
  console.log(this.contentContainer);
  const element = this.contentContainer?.nativeElement;
  const htmlContent = element.innerHTML;
  const blob = new Blob([htmlContent], {type: "text/html"});
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = "content.html";
  document.body.appendChild(a);
  a.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}


}